module.exports = __webpack_public_path__ + "img/add_img_af.f12419ab.svg";